import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

interface Props {
  translationPrefix: string;
}

const IndustryChecklistI18n = ({ translationPrefix }: Props) => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tArray } = useLanguage();
  const items = tArray(`${translationPrefix}.checklist.items`);

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={cn("py-16 md:py-24 bg-background transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center"><Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t(`${translationPrefix}.checklist.badge`)}</Badge></div>
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6 text-center">{t(`${translationPrefix}.checklist.title`)}</h2>
          <p className="text-lg text-muted-foreground text-center mb-10">{t(`${translationPrefix}.checklist.intro`)}</p>

          <div className="bg-secondary/50 rounded-2xl p-8 mb-8">
            <div className="space-y-4">
              {items.map((item, index) => (
                <div key={index} className={cn("flex items-start gap-4 p-4 bg-background rounded-xl border border-border transition-all duration-500", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4")} style={{ transitionDelay: isVisible ? `${index * 100}ms` : "0ms" }}>
                  <CheckCircle2 className="w-6 h-6 text-chathero-mint shrink-0 mt-0.5" />
                  <span className="text-foreground">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className={cn("bg-chathero-mint/10 border border-chathero-mint/30 rounded-2xl p-6 text-center transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")} style={{ transitionDelay: isVisible ? "500ms" : "0ms" }}>
            <p className="text-lg text-foreground mb-4">
              <strong>{t(`${translationPrefix}.checklist.conclusionBold`)}</strong>{" "}
              {t(`${translationPrefix}.checklist.conclusionText`)}
            </p>
            <p className="text-muted-foreground">{t(`${translationPrefix}.checklist.conclusionSub`)}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryChecklistI18n;
